import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/comics";
import SectionHeader from "@/components/feature/SectionHeader";

function FaqPreview() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  const preview = faqs.slice(0, 5);

  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <SectionHeader
            eyebrow="FAQ"
            title="会员常见问题"
            desc="关于专属漫画内容、会员特权阅读与豪华画质的常见疑问，为你一一解答。"
          />
          <div className="mt-8 rounded-lg border border-background-800 bg-background-900/60 p-6">
            <div className="flex items-center gap-4">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-accent-500 to-primary-600 text-xl text-foreground-950">
                <i className="ri-question-line"></i>
              </span>
              <p className="text-sm leading-6 text-foreground-400">
                还有疑问？查看完整常见问题，或联系我们的专属客服团队。
              </p>
            </div>
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-500/50 px-5 py-2.5 text-sm font-semibold text-primary-300 transition hover:bg-primary-500/10 cursor-pointer"
            >
              查看全部问答
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="space-y-3">
            {preview.map((f, idx) => {
              const open = openIdx === idx;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-lg border transition ${
                    open ? "border-primary-500/40 bg-background-900" : "border-background-800 bg-background-900/40"
                  }`}
                >
                  <button
                    onClick={() => setOpenIdx(open ? null : idx)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                    aria-expanded={open}
                  >
                    <span className="font-heading text-sm font-semibold text-foreground-100 md:text-base">
                      {f.q}
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-background-700 text-primary-400 transition ${
                        open ? "rotate-180" : ""
                      }`}
                    >
                      <i className="ri-arrow-down-s-line"></i>
                    </span>
                  </button>
                  {open && (
                    <p className="border-t border-background-800 px-5 py-4 text-sm leading-7 text-foreground-400">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default FaqPreview;